import Grid from '@mui/material/Grid2';
import { ParamPosSettings } from './ParamPosSettings';
import { ZiraatSettings } from './ZiraatSettings';
import { HalkbankSettings } from './HalkbankSettings';
import { BankTransferSettings } from './BankTransferSettings';
import { PreferredPaymentProviderSettings } from './PreferredPaymentProviderSettings';

export const PaymentSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <PreferredPaymentProviderSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }} />
      <Grid size={{ xs: 12, lg: 6 }}>
        <ZiraatSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <HalkbankSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <ParamPosSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <BankTransferSettings />
      </Grid>
    </Grid>
  );
};
